import type { PerAssessmentResponse } from '@lmc/ts-common'
import { EmptyState, NotStartedIcon } from '@lmc/ui-kit'
import { Spinner } from 'components/generic'
import dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { riskAssessmentReportConstants as translations } from 'locale/riskAssessmentReports'
import { useTranslation } from 'react-i18next'
import NoDataEmptyState from 'screens/Reports/RiskAssessmentDashboard/components/EmptyStates/NoDataEmptyState'
import type { PerAssessmentFilters } from '../DashboardFilters/DashboardFilters'
import DashboardTable from '../DashboardTable/DashboardTable'

interface DashboardBodyProps {
  isLoading: boolean
  filterParams: PerAssessmentFilters
  data?: PerAssessmentResponse
}

export const DashboardBody = ({
  isLoading,
  filterParams,
  data
}: DashboardBodyProps) => {
  const { t } = useTranslation(NAMESPACE.RISK_ASSESSMENT_REPORT)
  if (!filterParams.riskAssessment) {
    return (
      <EmptyState
        title={t(translations.EMPTY_STATE_RISK_ASSESSMENT_TITLE)}
        description={t(translations.EMPTY_STATE_ASSESSMENT_DESCRIPTION)}
        icon={<NotStartedIcon />}
      />
    )
  }

  if (isLoading) {
    return <Spinner />
  }

  if (!data?.result?.length) {
    return <NoDataEmptyState />
  }

  const { rangePicker } = filterParams

  return (
    <DashboardTable
      from={rangePicker?.[0] || dayjs()}
      to={rangePicker?.[1] || dayjs()}
      dataSource={data?.result || []}
    />
  )
}

export default DashboardBody
